import { useState } from 'react'
import { Link, useLocation } from 'react-router'
import { useSessione } from '../servizi/sessione.tsx'
import { ULTIMA } from '../guida/novita.ts'
import { visibile } from '../guida/indice.ts'
import { segnaVista, ultimaVista } from '../guida/vista.ts'
import { BottoneIcona } from './base.tsx'
import { IconaChiudi, IconaInfo } from './Icone.tsx'

/**
 * Avviso delle novità (decisione del 31/10/2026): al primo ingresso dopo una versione nuova, una riga
 * sopra la pagina porta alle Novità. Sparisce quando si apre la pagina o si chiude l'avviso, e non
 * torna fino alla versione dopo. Non compare se la versione non cambia niente per gli incarichi
 * dell'utente: un avviso senza niente da leggere insegna a ignorarli.
 */
export function AvvisoNovita() {
  const { io, puo } = useSessione()
  const { pathname } = useLocation()
  // Il ricordo si rilegge a ogni disegno: la pagina Novità lo aggiorna da sé, e uscendone l'avviso
  // non deve ricomparire. `ridisegna` serve solo dopo la chiusura con la crocetta.
  const [, ridisegna] = useState(0)
  if (!io || pathname === '/novita' || ultimaVista(io.id) === ULTIMA.numero) return null
  if (!ULTIMA.cambiamenti.some((c) => visibile(c.permesso, puo))) return null

  const segna = () => { segnaVista(io.id, ULTIMA.numero); ridisegna((n) => n + 1) }
  return (
    <div className="guida-avviso-novita" role="status">
      <IconaInfo />
      <p>
        <strong>Novità della versione {ULTIMA.numero}</strong>: {ULTIMA.inBreve}{' '}
        <Link to="/novita" onClick={segna}>Leggi le novità</Link>
      </p>
      <BottoneIcona icona={<IconaChiudi />} etichetta="Chiudi l’avviso delle novità" onClick={segna} />
    </div>
  )
}
